import { AutoMap } from "@automapper/classes"
import { ContractDTO } from "./contract.dto"

export class ClientDTO {
    @AutoMap()
    code!: string
    @AutoMap()
    name!: string
    @AutoMap()
    address!: string
    @AutoMap()
    city!: string
    @AutoMap()
    zipCode!: string
    @AutoMap(() => ContractDTO)
    contractList: ContractDTO[] = [];
    @AutoMap()
    elimsClientCode: string = '';
}